import { render, staticRenderFns } from "./modalRedeemProduk.vue?vue&type=template&id=492d6054&scoped=true"
import script from "./modalRedeemProduk.vue?vue&type=script&lang=js"
export * from "./modalRedeemProduk.vue?vue&type=script&lang=js"
import style0 from "./modalRedeemProduk.vue?vue&type=style&index=0&id=492d6054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492d6054",
  null
  
)

export default component.exports